export default __webpack_public_path__ + "static/media/nowhere.f4e3be34.png";